import { css, html, LitElement } from 'lit';
import { Text } from '../Text/Text.js';
import { WEB_CONTENT } from '../../../constants/content.js';
import { NoContactsPlaceholderSVG, NoContactsPlaceholdersvg } from '../../../assets/svg/NoContactsPlaceholder.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';


class NoContactsPlaceholder extends LitElement {
  static styles = css`

  .no-contacts-found {
      height: 100%;
      width: 100%;
      color: gray;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
        .no-contacts-found span:nth-child(2) {
      font-size: 28px;
      font-weight: 700;
      color: var(--text-primary-color);
    }

    .no-contacts-found span:nth-child(3) {
      font-size: 16px;
      font-weight: 400;
      color: var(--text-primary-color);
      text-align: center;
      padding: 0 10px;
    }

  `;
  static properties = {
  
  };


  render() {
   return html`
   <div class="no-contacts-found">
                 ${unsafeHTML(NoContactsPlaceholderSVG)}

    <span>${WEB_CONTENT.PLACEHOLDER_CONTENT.NO_CONTACTS_FOUND.TITLE}</span>
    <span>${WEB_CONTENT.PLACEHOLDER_CONTENT.NO_CONTACTS_FOUND.DESCRIPTION}</span>
   </div>
   `
  }




 
}

customElements.define('no-contacts-placeholder', NoContactsPlaceholder);
